<div class="abook-icon-label" title="{{ text() }}" [ngClass]="'size-' + size()">
  <mat-icon class="icon">{{ icon() }}</mat-icon>
  <span class="text">{{ text() }}</span>
</div>
